import { useMutation, useQueryClient } from "@tanstack/react-query";
import { OrderInterface } from "../../../interfaces/orderInterface";
import { ApiResponse } from "../../../interfaces/apiResponseInterface";
import orderApi from "../../../services/orderApi";
import {
  errorNotification,
  successNotification,
} from "../../../utils/notification";
import { ORDER_MESSAGES_ERROR, ORDER_MESSAGES_SUCCESS } from "../constants/messages";

export const useSaveOrderMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<ApiResponse<OrderInterface>, Error, OrderInterface>({
    mutationFn: (order) => orderApi.saveOrders(order),
    onSuccess: (res, variables) => {
      if (!res.ok) {
        errorNotification(ORDER_MESSAGES_ERROR.SAVE_ERROR);
        return;
      }
      successNotification(ORDER_MESSAGES_SUCCESS.SAVE_SUCCESS);
      queryClient.invalidateQueries({ queryKey: ["orders"] });
      if (variables._id) {
        queryClient.invalidateQueries({
          queryKey: ["order-by-id", variables._id],
        });
      } else if (res.data?._id) {
        window.open(`/invoice/${res.data._id}`, "_blank");
      }
    },
    onError: () => {
      errorNotification(ORDER_MESSAGES_ERROR.SAVE_ERROR);
    },
  });
};
